import { preparePythonPrediction } from "./python-prediction-request";
import { Firestore } from "firebase/firestore";
import { Functions, httpsCallable, HttpsCallable } from "firebase/functions";
import {
  AdsGenerationFromUrlsRequest,
  AdsGenerationFromUrlsResponse,
} from "../ads-generation-from-urls-types";
import type { FirebaseBackend } from "./firebase-backend";
import { AD_GENERATION_FROM_URLS } from "./firebase-function-name";

export class AdsGenerationFromUrlsManager {
  private getCurrentTeamId: () => string | null | undefined;

  private firestore: Firestore;

  private backend: FirebaseBackend;

  private adsGenerationFromUrls: HttpsCallable<
    AdsGenerationFromUrlsRequest,
    AdsGenerationFromUrlsResponse
  >;

  constructor({
    firestore,
    firebaseFunctions,
    backend,
    getCurrentTeamId,
  }: {
    firestore: Firestore;
    firebaseFunctions: Functions;
    backend: FirebaseBackend;
    getCurrentTeamId: () => string | null | undefined;
  }) {
    this.firestore = firestore;
    this.backend = backend;
    this.getCurrentTeamId = getCurrentTeamId;

    this.adsGenerationFromUrls = httpsCallable(firebaseFunctions, AD_GENERATION_FROM_URLS, {
      timeout: 180000,
    });
  }

  async generateAdsFromUrls(
    request: AdsGenerationFromUrlsRequest,
  ): Promise<AdsGenerationFromUrlsResponse> {
    try {
      const pending = await preparePythonPrediction(
        AD_GENERATION_FROM_URLS,
        request,
        this.getCurrentTeamId,
      );
      const response = await this.adsGenerationFromUrls(pending.request);
      await pending.confirm(response.data);
      return response.data;
    } catch {
      console.error("python_prediction_submission_unconfirmed");
      throw new Error("Failed to generate images from urls");
    }
  }
}
